import i18n from '@/setup/i18n.js';
import useSessionStore from '@/stores/session';


/**
 * Mixin can be included in components which needs a custom theme style class.
 * Per default it uses the global defined theme in the store/modules/session. It can be overwritten
 * with the prop "customTheme"
 *
 * @mixin
 */
export default {
  props: {
    /**
     * Custom theme to overwrite the global defined theme id
     */
    customTheme: {
      type: String,
      default: null,
    },
  },
  
  computed: {
    /**
     * Returns an Object with the active theme (global theme if nothing specific is defined).
     *
     * @returns {String} active theme id for BEM class name
     */
    theme() {
      return this.customTheme ?? useSessionStore().theme;
    },
  },

  methods: {
    /**
     * Checks if the given theme is the current theme.
     *
     * @param {String} theme - A matching theme name.
     *
     * @returns {Boolean}
     */
    isTheme(theme) {
      return this.theme === theme;
    },

    /**
     * Matches the translation key for the current theme.
     *
     * @param {Object} options - Object with the default translation key and the translation key for the current theme
     * @param {Object} values - Object to be passed to i18n for string interpolation
     *
     * @returns {String} - can be empty if no translation key is found
     */
    matchThemeTranslation(options, values) {
      let key = options.default;

      if (i18n.global.te(options[this.theme])) {
        key = options[this.theme];
      }

      return i18n.global.t(key, values) ?? key;
    },

    /**
     * Matches the value for the current theme from the given options.
     *
     * @param {Object} options - Object with the default value and the value for the current theme
     *
     * @returns {Any|null} - Can be empty if no value is found
     */
    matchTheme(options) {
      try {
        return this.theme in options ? options[this.theme] : options.default;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Key does not exist in theme config.', error.message);

        return null;
      }
    },
  },
};
